/**
 * Reusable form component building maps
 *
 * NOTE:  this DOESN'T work yet.  will need to rewrtie with recompose 
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from '../BaseComponent.js.jsx';

// import third-party libraries
import { GoogleMap, Marker, Polygon, withGoogleMap, withScriptjs } from 'react-google-maps';
const { compose, withProps, lifecycle } = require("recompose");
const { DrawingManager } = require("react-google-maps/lib/components/drawing/DrawingManager");
const { StandaloneSearchBox } = require("react-google-maps/lib/components/places/StandaloneSearchBox");


// google maps setup
const EditableMap = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultCenter={props.defaultCenter}
    defaultZoom={props.mapZoom}
    mapTypeId="terrain"
    onZoomChanged={props.onZoomChanged}
    onDragEnd={props.onMapDragEnd}
    ref={props.onMapMounted}
  >
    <DrawingManager
      defaultOptions={{
        drawingControl: true
        , drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER
          , drawingModes: props.drawingModes
        },
      }}
      onPolygonComplete={props.onPolygonComplete}
      onMarkerComplete={props.onMarkerComplete}
    />
    {
      props.markers.map(marker => (
        <Marker
          {...marker}
          clickable={true}
          draggable={true}
          onDragEnd={(location)=> props.onMarkerChange(location)}
        />
      ))
    }
    {
      props.polygons.map((polygon, i) => (
        <Polygon
          key={i}
          editable={true}
          draggable={true}
          onDragEnd={(p) => props.onPolygonMoved(p)}
          onMouseUp={(p) => props.onPolygonChange(p)}
          onMouseDown={(p) => props.onPolygonSetEdit(p)}
          paths={polygon}
          ref={props.onPolygonMounted}
          />
      ))
    }

  </GoogleMap>
));



// WEBPACK FOOTER //
// global/components/maps/EditableMap.js.jsx